<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                百家姓管理
            </div>
            
            <div>
                <!-- table组件 -->
                <div class="my_table">
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                            <Button class="mR5"    type="info"    @click='route="/layout/circle/surname/add";addFun();rpage=false' > <Icon type="md-add" />添加</Button>                              
                            </div>
                            
                        </Row>                    
                    </div>
            
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table     border :columns="columns1" :data="data1" ref='table'>
                    
                        
                        <!-- 预览 -->
                        <template slot-scope="{ row, index }" slot="content">                            
                            <Button v-if="row.id != id || !rpage " class="padlr5" size="small"  @click='ckFun(row.id);content=row.content;id=row.id'  type="info"  >查看内容</Button>                       
                            <Button v-if="row.id == id && rpage" class="padlr5" size="small"  @click='ckFun(row.id);content=row.content;id=row.id'  type="error"  >取消查看</Button>                       
                        </template>
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                            
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/surname/editor";editorFun(row);rpage=false'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/surname/del";delFun(row)'  type="error"   icon="md-close"></Button>
                            </Poptip>
                        
                        </template>
                        
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>

                    <!-- 预览 -->
                    <div v-if="rpage" class="phone">
                        <div  class="uditor1" v-html="content" ></div>
                        <Icon @click="rpage = false" class="phone_close" type="md-close-circle" />
                    </div> 
                    
                    <!-- 用户组编辑弹窗 -->
                    <Modal
                        :z-index="900"
                        v-model="modal1"
                        title="百家姓编辑"
                        width="600"
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel1'>取消</Button>
                            <Button type='primary' size='large' @click='ok1'>修改</Button>
                        </div>
                        <ul class="list_ul uh">
                        
                            <!-- ID -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input   v-model="sort"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>    
                            <!-- 姓氏 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 姓氏 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入姓氏"    />
                                </div>                                            
                            </li>
                            <!-- 链接 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 链接 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model4"    type='text' class="ipt"  placeholder="请输入链接"    />
                                </div>                                            
                            </li>
                            <!-- 状态 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 状态 :</div> 
                                <i-switch class="top7"  size="small" v-model="model2"  :true-value="Number(0)" :false-value="Number(1)"  @on-change="change_out_zt" />                                       
                            </li>                                          
                            <!-- 富文本 -->
                            <!-- <li>
                                <div class='list_title'> <span class="cRed">*</span> 内容 :</div> 
                                <div class="list_con">
                                    <fwb @txt="txt2" :msg1="content" :look='look'></fwb>
                                </div>                                            
                            </li> -->
                        
                        </ul>
                    </Modal>
                    
                    <!-- 用户组添加弹窗 -->
                    <Modal 
                        :z-index="900"
                        v-model="modal2"
                        title="百家姓添加"
                        width="600"
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel_add'>取消</Button>
                            <Button type='primary' size='large' @click='ok_add'>添加</Button>
                        </div>
                        <!-- {{model1}}-{{model2}}-{{model3}} -->
                        <ul class="list_ul uh">
                        
                                
                            <!-- ID -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input   v-model="sort"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>    
                            <!-- 姓氏 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 姓氏 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入姓氏"    />
                                </div>                                            
                            </li>
                            <!-- 链接 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 链接 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model4"    type='text' class="ipt"  placeholder="请输入链接"    />
                                </div>                                            
                            </li>
                            <!-- 状态 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 状态 :</div> 
                                <i-switch class="top7"  size="small" v-model="model2"  :true-value="Number(0)" :false-value="Number(1)"  @on-change="change_out_zt" />                                       
                            </li>      
                            <!-- 富文本 -->
                            <!-- <li>
                                <div class='list_title'> <span class="cRed">*</span> 内容 :</div> 
                                <div class="list_con">
                                    <fwb @txt="txt2" :msg1="content" :look='look'></fwb>
                                </div>                                            
                            </li> -->
                        
                        </ul>
                    </Modal>
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        @on-cancel="cancel"
                        class-name="vertical-center-modal"
                    >
                        <p>确定删除吗?</p>
                        
                    </Modal>
                    
                </div>

            </div>
        </div>
        
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    import fwb from '../../child_vue/fwb.vue';

    export default {
        name:'classify',
        data () {
            return {
                route: null,
                token:'',
                rpage: false,  //预览
                look: false,
                columns1:[],
                  
                data1:[],
                content: '',

                checkGuid2:'',
           
                sort: null,  //排序
                preId: null,
                id: null,   // 类似guid
                modal1: false, // 编辑百家姓
                modal2: false,   //添加百家姓
                delM: false,

                model1: null,
                model2: 0,
                model3: '',
                model4: null, //链接

                total: 1,
                page: 1,
                size: 20,
                
            }
        },
     
        watch:{
           modal1(val){
               this.look = val;
           },
           modal2(val){
               this.look = val
           },
          
           
        },
       
        computed: {
         
         
            
        },
        components:{"fwb":fwb},
        methods: {
           load(){
              let that = this;
              
              that.$myAjax.get('admin/service/admin/surname?page='+that.page +'&size='+that.size).then(res => {
                   
                    that.data1 = res.data.data.list;
                    that.total = res.data.data.total;

                    that.columns1 = [
                       {title:'排序',key:'sort',align:'center',},
                       {title:'姓氏',key:'surname',align:'center',}, 
                       {title:'链接',key:'url',align:'left',}, 
                    //    {title:'预览',slot:'content',align:'center',},                    
                    //    {title:'添加时间',key:'createTime',align:'center',width: 120},
                       {title:"状态",key:"display",align:"center",
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.isDisplay == "0"
                                      },
                                      on: {
                                          'on-change': (value) => {
                                              let val;
                                              if(value){
                                                val = 0
                                              }else{
                                                val = 1
                                              }

                                              that.$myAjax.put('admin/service/admin/surname?route=/layout/circle/surname/editor',
                                                  {
                                                      "id": params.row.id,
                                                      "isDisplay": val
                                                  }
                                              ).then(res => {
                                                  that.load();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }
                        },
                        {title:'操作',slot:'btn',align:'center',width: 180,fixed: 'right'}

                   ];
                   
                });
                
           },

          
            
           // 用户组名编辑
            editorFun(res){
                let that = this;
               

                that.$canBtn( that.route).then( function(res_c){
                    that.modal1 = true;
                    
                    that.id = res.id;
                    that.sort = res.sort;
                    that.model1 = res.surname; 
                    that.model2 = res.isDisplay;
                    that.model4 = res.url;
                    that.content = res.content;
                    
                    
                })
            },
           

            //    编辑弹窗
            ok1() {
                var that = this;
                that.$myAjax.put('admin/service/admin/surname?route='+that.route,
                    { 
                        "id": that.id,
                        "sort": that.sort,
                        "surname": that.model1,
                        "isDisplay": that.model2,
                        "content": that.model3,
                        "url": that.model4
                    },
                    
                ).then(res => {
                    
                    if(res.data.code == 1){
                        that.load();
                        that.cancel1();
                    }
                }).catch(err=>{
                    console.log(err)
                })

                
                
            },
            cancel1() {
                this.modal1 = false;
                
               
            },
           
            // 删除用户组
            delFun(res){
                let that = this;

                
                that.$canBtn( that.route).then( function(res_c){
                    that.id = res.id;
                    that.delM = true;
                })
            },
            delOk(){
                let that = this;
                that.$myAjax.delete('admin/service/admin/surname?id='+that.id+'&route='+that.route).then(res => {
                   
  
                    that.load();
                })
                
            },
            
            
            // 顶部添加
            
            addFun(){
                let that = this;
              
                that.$canBtn( that.route).then( function(res_c){
                    that.modal2 = true;
                  
                    that.sort = null;
                    that.model1 = null;
                    that.model2 = 0;
                    that.model4 = null;
                    that.content = '';
                    
                    
                })  
            },
            ok_add(){
                let that = this;
                
                that.$myAjax.post('admin/service/admin/surname?route='+that.route,{
                    "sort": that.sort,
                    "surname": that.model1,
                    "isDisplay": that.model2,
                    "content": that.model3,
                    "url": that.model4
                }).then(res => {
                   
                    
                    if(res.data.code != 0){
                        that.load();
                        that.cancel_add();
                    }
                    
                })
                    
                
               
            },
            cancel_add(){
            
                this.modal2 = false;
                
            },

            cancel(){},

            change_page(index){
                this.load();
            },
            change_size(size){
                this.size = size;
                this.load();
                
            },
            change_out_zt(){

            },

            txt2(data){
                this.model3 = data;
                console.log('fwb',data)
            },
            ckFun(opt){       //查看内容
                var that = this;
               
                if(that.preId == opt){
                    if(that.rpage){
                        that.rpage = false;
                    }else{
                        that.rpage = true;
                    }
                    console.log(1,that.preId,opt)
                }else{
                    that.rpage = true;
                    console.log(2,that.preId,opt)
                }
                that.preId = opt;

            }
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;
           
           that.token = that.$store.state.token;
           
           that.load();
          
           
           
           
           
            
        }
    }
</script>
<style scoped>
     /* public 内容用  /就行 */
     @import "/css/modal.css";

     /* 表格下方无翻页按钮时 */
    .ivu-table-wrapper{
        margin-bottom: 50px;
    }

    .ipt{
        width: 415px!important;
    }
    .list_ul .list_title{
        width: 120px;
    }
    .uh{
        height: 200px;
        overflow: hidden;
        overflow-y: auto;
    }

    
    
</style>




